export default __webpack_public_path__ + "static/media/apple-MacPro.71f48679.jpg";